import { useSubscriber } from 'app/socketConnection';
import { LockActionData } from 'entities/Box/model/types';

export const useOnLockOpenTooLong = (): Nullable<LockActionData> => useSubscriber<LockActionData>('lockOpenTooLong');
